import { render } from "./ImagePlus.vue?vue&type=template&id=62a53f49"
import script from "./ImagePlus.vue?vue&type=script&lang=js"
export * from "./ImagePlus.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/ImagePlus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62a53f49"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62a53f49', __exports__)) {
    api.reload('62a53f49', __exports__)
  }
  
  module.hot.accept("./ImagePlus.vue?vue&type=template&id=62a53f49", () => {
    api.rerender('62a53f49', render)
  })

}


export default __exports__